import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { DIMBO_CONSTANT } from '../utils/constant';

@Injectable({
  providedIn: 'root'
})
// Service for submitting BrandCare form data.
export class FormSubmissionService {
  domain: string;

  constructor(private httpService: HttpService, private apiconfig : AppConfig) {
      var apipath='';
        // if(this.apiconfig.mpsaFlag==='N'){
        //   apipath = location.protocol + '//' + this.apiconfig.apiUrl;
        // }
        apipath=this.apiconfig.apiUrl;
      this.domain = apipath+this.apiconfig.apiPath;
    }

    /**
   * Submits the form data to the backend API.
   * @param formData The data to be submitted.
   * @returns Observable of the API response.
   */
  submitForm(formData: any): Observable<any> {
    const finalUrl = this.domain + DIMBO_CONSTANT.BRANDCARE_SUBMISSION;
    return this.httpService.post(finalUrl,formData);
  }
}
